import type { RingBuyStepId } from 'components/ring-air/utils/buySteps';

// Ultrahuman MAX replaces the UHX coverage and PowerPlug steps.
export const RING_PRO_BUY_STEP_ORDER: RingBuyStepId[] = [
  'color-picker',
  'size-select',
  'charger-select',
  'trade-in',
  'clue-addon',
  'max',
  'order-overview',
];
